import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import moment from "moment/moment";
import { saveAs } from "file-saver";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import SwalServices from "../../../services/swalServices/SwalServices";
import MembershipCorporateServices from "../../../services/axiosServices/apiServices/MembershipCorporateServices";
import Table from "../../../components/table/Table";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import { CommonSuccessMessages } from "../../../utils/Messages";
import { checkParameters, encryptAES } from "../../../utils/Encryption";
import CorporateMemberServices from "../../../services/axiosServices/apiServices/CorporateMemberServices";
import CommonServices from "../../../services/axiosServices/apiServices/CommonServices";
import TextInput from "../../../components/UIComponent/TextInput";
import ManagePostingModal from "./ManagePostingModal";
import IndividualMemberService from "../../../services/axiosServices/apiServices/IndividualMemberService";
import { SuccessMessage } from "../../../utils/Messages";

import {
  APIURL,
  GetImage as getImage,
} from "../../../services/axiosServices/ApiEndPoints";
import { DeleteButtonIcon } from "../../../components/SVGConstants";
import { getAuditContext } from "../../../utils/AuthenticationLibrary";
export default class ManagePosting extends Component {
  constructor(props) {
    super(props);
    this.membershipCorporateServices = new MembershipCorporateServices();
    this.corporateMemberServices = new CorporateMemberServices();
    this.individualMemberService = new IndividualMemberService();
    this.commonServices = new CommonServices();
    this.swalServices = new SwalServices();
    this.state = {
      // pagination: {
      //   pageNo: 1,
      //   pageSize: 10,
      //   orderByColumn: "",
      //   orderFlag: 0,
      //   searchText: "",
      //   searchByUENNumber: "",
      //   paymentStatusId: 0,
      //   formStatusId: 0,
      //   membershipTypeId: 0,
      //   renewalYear: 0,
      // },
      pagination: {
        pageNo: 1,
        pageSize: 10,
        collaborationPortalPostingId: 0,
      },
      documentList: [],
      updatedAppId: 0,
      updatedBy: 0,
      isLoadingcancelInvoice: false,
      councilIndex: 0,
      setRepresentativeDetailsModal: false,
      receiverOrganisationName: "",
      renewalMemberList: [],
      totalMembersFullyRenewed: 0,
      totalMembersPaid: 0,
      totalMembersDeclared: 0,
      renewalYear: 0,
      dataGetting: false,
      represenativesData: [],
      totalResultes: 0,
      totalMembers: 0,
      collaborationPortalPostingId: 0,
      collaborationResponsesList: [],

      postingDetails: {
        collaborationPortalPostingId: 0,
        title: "",
        description: "",
        supportingDocumentPath: "",
        deadlineDate: null,
        name: "",
        postedOn: null,
        companyName: "",
        isActive: null,
      },
      paymentStatus: [
        { id: 1, name: "Pending" },
        { id: 3, name: "Submitted" },
        { id: 2, name: "Paid" },
      ],
      formStatus: [
        { id: 1, name: "Pending" },
        { id: 3, name: "Submitted" },
        { id: 2, name: "Updated" },
      ],
      membershipTypes: [],
      actionDropdown: ["Activate", "Deactivate", "Update", "Delete"],
    };
  }

  componentDidMount() {
    let params = new URLSearchParams(window.location.search);
    let postingId = params.get("collaborationPortalPostingId");
    this.getAllCorporateStatus();
    this.getAllDropdownForCorporateMember();
    document.addEventListener("mousedown", this.handleClickOutside);

    if (postingId && (postingId = checkParameters(postingId, "Number"))) {
      if (postingId !== null && postingId > 0) {
        this.setState({ collaborationPortalPostingId: postingId });
      }
    }
    this.getPostingDetailsbyId(postingId);
    this.getPostDocumentsById(postingId);
    this.getAllCollaborationResponsesList(postingId)
  }

  getPostingDetailsbyId = (id) => {

    if (id > 0) {
      this.individualMemberService
        .getPostingDetailsbyId(id)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            let res = { ...this.state.postingDetails };
            res.collaborationPortalPostingId =
              response.responseItem.responseContent.collaborationPortalPostingId;
            res.title = response.responseItem.responseContent.title;
            res.description = response.responseItem.responseContent.description;
            res.supportingDocumentPath =
              response.responseItem.responseContent.supportingDocumentPath;
            res.deadlineDate =
              response.responseItem.responseContent.deadlineDate;
            res.name = response.responseItem.responseContent.name;
            res.postedOn = response.responseItem.responseContent.postedOn;
            res.companyName = response.responseItem.responseContent.companyName;
            res.isActive = response.responseItem.responseContent.isActive;
            this.setState({ postingDetails: res });
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };
  getPostDocumentsById = (id) => {
    if (id > 0) {
      this.individualMemberService.getPostDocumentsById(id).then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          this.setState({
            documentList: response.responseItem.responseContent,
          });
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
  };

  handleChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    let postingDetails = { ...this.state.postingDetails };
    postingDetails[name] = value;
    this.setState({ postingDetails: postingDetails });
  };

  getAllCollaborationResponsesList = (id) => {
    if (id > 0) {
      let req = { ...this.state.pagination };
      req.collaborationPortalPostingId = id
      // this.state.collaborationPortalPostingId;
      this.individualMemberService
        .getAllCollaborationResponsesList(req)
        .then((response) => {
          if (response.statusCode === 200 && response.responseItem != null) {
            if (response.responseItem.responseContent != null) {
              const formattedResponses =
                response.responseItem.responseContent.itemList.map((respondedItem) => ({
                  ...respondedItem,
                  respondedOn: respondedItem.respondedOn
                    ? moment(respondedItem.respondedOn).format("DD MMM yyyy")
                    : null,
                }))


              this.setState({
                collaborationResponsesList:formattedResponses,
                totalResultes: response.responseItem.responseContent.totalCount,
              });
            } else {
              this.swalServices.Error("something went wrong");
            }
          } else {
            this.SwalServices.Error(response.message);
          }
        });
    }
  };

  setFilterParameters = (id, drpIdentity) => {
    let detail = this.state.pagination;
    detail.pageNo = 1;

    if (drpIdentity === "MembershipType") {
      detail["membershipTypeId"] = id;
    }

    if (drpIdentity === "PaymentStatus") {
      detail["paymentStatusId"] = id;
    }

    if (drpIdentity === "FormStatus") {
      detail["formStatusId"] = id;
    }

    if (drpIdentity === "RenewalYear") {
      detail["renewalYear"] = id === null ? 0 : id;
    }

    this.setState({ pagination: { ...detail } });
    this.getAllRenewalList();
  };

  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "searchByCompanyName") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    } else if (identity === "searchByUENNumber") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchByUENNumber = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getAllCollaborationResponsesList();
  };

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination }, () => {
      this.getAllCollaborationResponsesList(
        this.state.collaborationPortalPostingId
      );
    });

  };

  onClose = () => {
    this.setState({ setDropdownOpen: false });
  };

  actionClick = (index, value, option) => {
    if (value && value > 0 && option === "Deactivate") {
      this.deActivateCorporateMemnber(value);
    }
    if (value && value > 0 && option === "Activate") {
      this.activeInActiveCorporateMember(value);
    }
    if (value && value > 0 && option === "Update") {
      this.updateCorporateMemberUpdate(value);
    }
    if (value && value > 0 && option === "Delete") {
      this.deleteCorporateMember(value);
    }
  };

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ setDropdownOpen: false });
    }
  }
  deActivateCorporateMemnber = (value) => {
    let request = {
      id: value,
      statusId: 7,
    };
    this.setState({ isLoading: true });
    this.membershipCorporateServices
      .activeInActiveCorporateMember(request)
      .then((response) => {
        if (response.statusCode === 200) {
          this.swalServices.Success(
            "Corporate member deactivated Successfully."
          );
          this.getAllRenewalList();
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  activeInActiveCorporateMember = (value) => {
    let request = {
      id: value,
      statusId: 8,
    };
    this.setState({ isLoading: true });
    this.membershipCorporateServices
      .activeInActiveCorporateMember(request)
      .then((response) => {
        if (response.statusCode === 200) {
          this.swalServices.Success("Corporate member activated Successfully.");
          this.getAllRenewalList();
        } else {
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };
  cancelInvoiceAndRegenerateRenewalInvoice = (id, id2) => {
    if (id > 0 && id != null) {
      let request = [id, id2];
      this.setState({ isLoadingcancelInvoice: true });
      this.corporateMemberServices
        .cancelInvoiceAndRegenerateRenewalInvoice(request)
        .then((response) => {
          if (
            response.statusCode === 200 &&
            response.responseItem.responseContent != null
          ) {
            this.swalServices.Success("Invoice regenerated Successfully");

            this.setState({ setRepresentativeDetailsModal: false, isLoadingcancelInvoice: false });
          } else {
            this.swalServices.Warning("Invoice not regenerated");
            this.setState({ setRepresentativeDetailsModal: false, isLoadingcancelInvoice: false });
          }
        });
    }
  };
  updateCorporateMemberUpdate = (value) => {
    if (value && value > 0) {
      this.setState({
        route:
          "/CreateCorporateMembers/CorporateMemberId?=" + encryptAES(value),
      });
    }
  };

  deleteCorporateMember = (value) => {
    let request = {
      id: value,
      deletedBy: 1,
      appId: 115,
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.membershipCorporateServices
            .deleteCorporateMember(request)
            .then((response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Deleted");
                this.getAllRenewalList();
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  actions = (element, index, value) => {
    return element !== "corporateMemberId" ? null : (
      <td>
        <ActionContainer>
          <DropdownAction
            key={index}
            index={index}
            value={value}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </td>
    );
  };

  actions2 = (element, index, value) => {
    return element !== "organisationName" ? null : (
      <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt break-all text-center">
        <button
          className="flex items-center justify-center"
          onClick={(e) => {
            e.preventDefault();
            this.setState({
              receiverOrganisationName:
                this.state.renewalMemberList[index].organisationName,
            });
            this.showRepresentativesDetails(e, value, index);
          }}
        >
          <span className="text-[#3e397c] underline font-bold mr-8 2xl:text-[15px]">
            {this.state.renewalMemberList[index].organisationName}
          </span>
        </button>
      </td>
    );
  };

  redirectTomanagePosting = (value) => {
    this.setState({
      route: "/ViewResponse?collaborationPortalPostingId=/" + encryptAES(this.state.collaborationPortalPostingId) + "/" + encryptAES(value),
    });
  };
  actions3 = (element, index, value) => {

    return (
      <span
        onClick={() => this.redirectTomanagePosting(value)}
        style={{
          color: "red",
          textDecoration: "underline",
          fontSize: "16px",
          display: "inline-block",
          marginTop: "17px",
          marginLeft: "22px",
          cursor: "pointer",
        }}
      >
        View
      </span>
    );
  };

  showRepresentativesDetails = (e, id, index) => {
    e.stopPropagation();
    this.setState({ councilIndex: index, setRepresentativeDetailsModal: true });
  };

  getAllCorporateStatus = () => {
    this.membershipCorporateServices
      .getAllCorporateStatus()
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          //this.setState({ statuses: response.responseItem.responseContent }, () => this.getAllRenewalList());
          // this.getAllRenewalList();
        } else {
          // this.getAllRenewalList();
          this.swalServices.Error(response.message);
        }
        this.setState({ isLoading: false });
      });
  };

  getAllDropdownForCorporateMember = () => {
    this.corporateMemberServices
      .getAllDropdownForCorporateMember()
      .then((response) => {
        if (response.statusCode === 200 && response.responseItem != null) {
          let membershipType = response.responseItem.responseContent.filter(
            (drp) => drp.dropdownName === "MembershipType"
          );
          this.setState({ membershipTypes: membershipType });
        }
      });
  };

  // getAllRenewalList = (pagination = this.state.pagination) => {
  //   pagination.renewalYear =
  //     this.state.pagination.renewalYear === 0
  //       ? new Date().getFullYear()
  //       : this.state.pagination.renewalYear;
  //   this.setState({ isLoading: true });
  //   this.corporateMemberServices
  //     .getAllRenewalList(pagination)
  //     .then((response) => {
  //       if (response.statusCode === 200 && response.responseItem != null) {
  //         let details = response.responseItem.responseContent.itemList;

  //         let totalMembersFullyRenewed = 0;
  //         let totalMembersPaid = 0;
  //         let totalMembersDeclared = 0;
  //         let totalMembers = 0;

  //         let renewalYear = "";

  //         details.map((key, index) => {
  //           key.renewalDate =
  //             key.renewalDate === "Invalid date"
  //               ? "-"
  //               : moment(key.renewalDate).format("DD MMM YYYY");
  //           key.paidDate =
  //             key.paidDate === "Invalid date" ||
  //             !moment(key.paidDate, moment.ISO_8601, true).isValid()
  //               ? "-"
  //               : moment(key.paidDate).format("DD MMM YYYY");
  //           if (key.membershipTypeName === "Associate") {
  //             key.formDate = "NA";
  //           } else {
  //             key.formDate =
  //               key.formDate === "Invalid date" ||
  //               !moment(key.formDate, moment.ISO_8601, true).isValid()
  //                 ? "-"
  //                 : moment(key.formDate).format("DD MMM YYYY");
  //           }
  //           if (key.organisationName === null || key.organisationName === "") {
  //             key.organisationName = "-";
  //           }
  //           if (key.organisationUEN === null || key.organisationUEN === "") {
  //             key.organisationUEN = "-";
  //           }
  //           totalMembersFullyRenewed = key.totalMembersFullyRenewed || 0;
  //           totalMembersPaid = key.totalMembersPaid || 0;
  //           totalMembersDeclared = key.totalMembersDeclared || 0;
  //           totalMembers = key.totalMembers || 0;

  //           renewalYear = key.renewalYear;
  //           return key;
  //         });
  //         this.setState({
  //           totalMembersFullyRenewed,
  //           totalMembersPaid,
  //           totalMembersDeclared,
  //           renewalYear,
  //           totalMembers,
  //         });
  //         this.setState({ renewalMemberList: details }, () =>
  //           this.setState({ dataGetting: true })
  //         );
  //         this.setState({
  //           totalResultes: response.responseItem.responseContent.totalCount,
  //         });
  //       } else {
  //         this.swalServices.Error(response.message);
  //       }
  //       this.setState({ isLoading: false });
  //     });
  // };
  getDateForFileName() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}${month}${day}`;
  }


  editPostingDetails = () => {
    const audit = getAuditContext()
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_update_Posting_Memebr_Information.replace(
          "{0}",
          "Admin"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          let request = this.state.postingDetails;
          request.updatedAppId = audit.appId;
          request.updatedBy = audit.adminUserId;
          this.setState({ isLoading: true });
          this.individualMemberService
            .editPostingDetails(request)
            .then((response) => {
              if (
                response.statusCode === 200 &&
                response.responseItem != null
              ) {
                this.swalServices.Success(
                  "Posting Details Updated successfully"
                );
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  deletePostingDetails = (value) => {
    const audit = getAuditContext()
    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId,
    };
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Post"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "Post"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.individualMemberService
            .deletePostingDetails(request)
            .then((response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Deleted");
                window.location.href = "/ViewPosting";
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };

  unpublishPost = (value) => {
    const audit = getAuditContext()
    let req = [value, audit.adminUserId];
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_update_Posting_status.replace(
          "{0}",
          "Status"
        ),
        "",
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
        if (response) {
          this.individualMemberService
            .unPlublishCollaborationPostById(req)
            .then((response) => {
              if (response.statusCode === 200) {
                this.swalServices.Success("Status has changed!");
                this.getPostingDetailsbyId(
                  this.state.collaborationPortalPostingId
                );
              } else {
                this.swalServices.Error(response.message);
              }
              this.setState({ isLoading: false });
            });
        }
      });
  };
  handleRemoveDocument = (keyToRemove) => {
    const docToDelete = this.state.documentList.find((doc) => {
      const docKey =
        doc.collaborationPortalDocumentMappingId > 0
          ? `db-${doc.collaborationPortalDocumentMappingId}`
          : `new-${doc.tempKey}`;
      return docKey === keyToRemove;
    });

    const updatedList = this.state.documentList.filter((doc) => {
      const docKey =
        doc.collaborationPortalDocumentMappingId > 0
          ? `db-${doc.collaborationPortalDocumentMappingId}`
          : `new-${doc.tempKey}`;
      return docKey !== keyToRemove;
    });
    this.swalServices.Success(
      SuccessMessage.Delete_Success.replace("{0}", "document")
    );

    this.setState({ documentList: updatedList }, () => {
      if (docToDelete && docToDelete.collaborationPortalDocumentMappingId > 0) {
        this.onDelete(docToDelete.collaborationPortalDocumentMappingId);
      }
    });
  };


  uploadDocuments = (event) => {
    const files = Array.from(event.target.files);
    const validFileTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/msword",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "image/jpeg",
      "image/png",
    ];

    const fileUploadPromises = files.map((file) => {
      if (!validFileTypes.includes(file.type)) {
        this.swalServices.Error(
          `Invalid file type: ${file.name}. Allowed formats: jpeg, png, pdf, doc, docx, xls, xlsx.`
        );
        return Promise.reject();
      }

      const request = {
        storagePath: "CollaborationPublishPostDocuments",
        file: file,
        fileName: file.name,
      };

      return this.commonServices.uploadPDF(request).then((response) => {
        if (response != null) {

          this.addDocument(this.state.postingDetails.collaborationPortalPostingId, response.fileName)

          return {
            collaborationPortalDocumentMappingId: 0,
            collaborationPortalPostingId: this.state.postingDetails.collaborationPortalPostingId,
            documentPath: response.fileName,
            tempKey: `${Date.now()}-${Math.random()
              .toString(36)
              .substring(2, 8)}`,
          };

        } else {
          this.swalServices.Error(`Failed to upload file: ${file.name}`);
          return null;
        }
      });
    });

    Promise.all(fileUploadPromises)
      .then((uploadedDocs) => {
        const validDocs = uploadedDocs.filter(Boolean);

        if (validDocs.length > 0) {
          this.setState(
            (prevState) => ({
              documentList: [...prevState.documentList, ...validDocs],
            }));
        }
      })
      .catch(() => {});
  };
  onDelete = (value) => {
    const audit = getAuditContext()
    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId,
    };

      if(request){
      this.individualMemberService
        .deleteCollaborationPostDocumentById(request)
        .then((response) => {
          if (response.statusCode === 200) {
            this.getPostDocumentsById(this.state.collaborationPortalPostingId);
          } else {
            this.swalServices.Error(response.message);
          }
          this.setState({ isLoading: false });
        });
    }
  };

    addDocument = (id,path) => {
    let req = {
        collaborationPortalPostingId : id,
        documentPath : path,
        createdBy : 115
    }
          if(req){
      this.individualMemberService
        .addCollaborationPostDocument(req)
        .then((response) => {
          if (
            response.statusCode === 200 &&
            response.responseItem != null
          ) {
            this.swalServices.Success(
              "Document uploaded Successfully!"
            );
          } else {
            this.swalServices.Error(response.message);
          }
        });
    }
  };


  back = () => {
      this.setState({  route: "/ViewPosting"  });
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <div className="main-body-section">
        <main className="pb-10">
          <div className="custom-card shadow-lg mb-4 rounded-md">
            <div className="main-sub-title">Posting Details</div>

            <div className="w-full ">
              <div className="border-card">
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Company Name:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      name="companyName"
                      className="w-full"
                      value={this.state.postingDetails.companyName}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>
                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Title :<span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="title"
                      value={this.state.postingDetails.title}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                    //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12  mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Description:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <textarea
                      className="w-full h-[120px]"
                      placeholder=""
                      rows="2"
                      value={this.state.postingDetails.description}
                      name="description"
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Supported Documents:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <form className="custom-uploader  flex items-center  text-center px-14 py-3">
                      <label
                        htmlFor="upload"
                        className="text-uplod btn-upload lg:text-[16px] text-[16px] text-black"
                      >
                        Upload Documents
                      </label>


                      <input
                        className="sr-only"
                        id="upload"
                        type="file"
                        onChange={(event) => this.uploadDocuments(event)}
                      />
                    </form>

                    {Array.isArray(this.state.documentList) &&
                      this.state.documentList.length > 0 && (
                        <ul>
                          {this.state.documentList.map((file, index) => {
                            const fileName = file.documentPath;
                            const isSaved =
                              file.collaborationPortalDocumentMappingId > 0;
                            const key = isSaved
                              ? `db-${file.collaborationPortalDocumentMappingId}`
                              : `new-${file.tempKey}`;
                            const lowerFile = fileName.toLowerCase();

                            const isPDF = lowerFile.endsWith(".pdf");
                            const isImage =
                              lowerFile.endsWith(".jpg") ||
                              lowerFile.endsWith(".jpeg") ||
                              lowerFile.endsWith(".png");
                            const isWord =
                              lowerFile.endsWith(".doc") ||
                              lowerFile.endsWith(".docx");
                            const isExcel =
                              lowerFile.endsWith(".xls") ||
                              lowerFile.endsWith(".xlsx");

                            const openOfficeViewer = (fileName, type) => {
                              const url = `${APIURL}Common/getFile?type=${type}&fileName=${encodeURIComponent(
                                fileName
                              )}`;
                              window.open(url, "_blank");
                            };

                            return (
                              <li
                                key={key}
                                className="text-[#757575] flex items-center gap-2 mb-2"
                              >
                                {isPDF ? (
                                  <a
                                    href={`${APIURL}Common/GetPDF?type=CollaborationPublishPostDocuments&&fileName=${encodeURIComponent(
                                      fileName
                                    )}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-red-400 common-fonts-size mobile-14"
                                  >
                                    {fileName}
                                  </a>
                                ) : isImage ? (
                                  <a
                                    href={`${APIURL}${getImage}?type=CollaborationPublishPostDocuments&&fileName=${encodeURIComponent(
                                      fileName
                                    )}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-red-400 common-fonts-size mobile-14"
                                  >
                                    {fileName}
                                  </a>
                                ) : isWord || isExcel ? (
                                  <button
                                    type="button"
                                    onClick={() =>
                                      openOfficeViewer(
                                        fileName,
                                        "CollaborationPublishPostDocuments"
                                      )
                                    }
                                    className="text-red-400 common-fonts-size mobile-14"
                                  >
                                    {fileName}
                                  </button>
                                ) : (
                                  <span>{fileName}</span>
                                )}

                                <button
                                  type="button"
                                  onClick={() => this.handleRemoveDocument(key)}
                                  className="ml-2 text-sm text-red-600 hover:underline"
                                >
                                  <DeleteButtonIcon />
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Deadline:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <input
                      id="default"
                      placeholder=""
                      type="date"
                      name="deadlineDate"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(
                        this.state.postingDetails.deadlineDate
                      ).format("YYYY-MM-DD")}
                      onChange={(e) => this.handleChange(e)}
                    //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Posted On:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <input
                      id="default"
                      placeholder=""
                      type="date"
                      name="postedOn"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      value={moment(this.state.postingDetails.postedOn).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) => this.handleChange(e)}
                    //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="grid lg:gap-4 gap-2 grid-cols-12 items-center mt-4">
                  <h2 className="text-xl font-bold theme-color mb-1 2xl:col-span-3  lg:col-span-3 col-span-3">
                    Posted By:
                    <span className="text-[#c00000]">*</span>
                  </h2>
                  <div className="2xl:col-span-9 lg:col-span-9 col-span-9 ">
                    <TextInput
                      placeholder=""
                      type="text"
                      name="name"
                      value={this.state.postingDetails.name}
                      identity="Posting_Detail"
                      handleChange={(e) => this.handleChange(e)}
                      disabled={true}
                    //   onBlur={(e) => props.ValidateAdminDetails("name")}
                    />
                  </div>
                  {/* <ValidationText
                        error={props.validState.error.name}
                      /> */}
                </div>

                <div className="col-span-12">
                  <div className="btn-sec">
                    <div className="left-btn-sec">
                      <button
                        className="delete-btn text-white sm:ml-10 ml-9 font-bold whitespace-nowrap  inline-flex items-center justify-center px-4 py-2 "
                        onClick={() =>
                          this.deletePostingDetails(
                            this.state.postingDetails
                              .collaborationPortalPostingId
                          )
                        }
                      >
                        Delete
                      </button>
                    </div>
                    <div className="right-btn-sec">
                      <button
                        className="unpublish-btn text-white sm:ml-10 ml-9 font-bold whitespace-nowrap  inline-flex items-center justify-center px-4 py-2 "
                        onClick={() =>
                          this.unpublishPost(
                            this.state.postingDetails
                              .collaborationPortalPostingId
                          )
                        }
                      >
                        {this.state.postingDetails.isActive === true
                          ? "UnPublish"
                          : "Publish"}
                      </button>
                      <button
                        className="edit-btn text-white sm:ml-10 ml-9 font-bold whitespace-nowrap  inline-flex items-center justify-center px-4 py-2 "
                        onClick={(event) => this.editPostingDetails(event)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mx-auto">
            <div className="relative">
              <div className="main-sub-title">Responses</div>
              <div>
                <div className="" onMouseLeave={() => this.onClose()}>
                  <Table
                    columns={[
                      { name: "senderCompanyName", title: "Company Name" },
                      { name: "senderName", title: "Contact Person" },
                      { name: "senderEmail", title: "Email Address" },
                      { name: "senderContactNumber", title: "Mobile Number" },
                      { name: "senderMessage", title: "Message" },
                      { name: "respondedOn", title: "Responded On" },
                      { name: "collaborationPostResponseId", title: "Action"}
                    ]}
                    rows={this.state.collaborationResponsesList}
                    isLoading={this.state.isLoading}
                    sortingColumns={[]}
                    pagination={this.state.pagination}
                    totalResultes={this.state.totalResultes}
                    totalCount={this.state.totalResultes}
                    setPagination={this.setPagination.bind(this)}
                    customScope={[
                      {
                        column: 'collaborationPostResponseId',
                        renderTableData: this.actions3.bind(this)
                      },

                    ]}
                  />
                </div>
              </div>
            </div>
            <div className="members-modal-sec membersdirectoery">
              {this.state.dataGetting === true &&
                this.state.renewalMemberList.length > 0 ? (
                // <RepresentativeDetailsModal
                //   councilIndex={this.state.councilIndex}
                //   getMemberDirectoryData={this.state.renewalMemberList}
                //   setRepresentativeDetailsModal={
                //     this.state.setRepresentativeDetailsModal
                //   }
                //   charLimit={this.state.charLimit}
                //   setOpenModal={() =>
                //     this.setState({ setRepresentativeDetailsModal: false })
                //   }
                //   onClose={(e) => {
                //     e.stopPropagation();
                //     this.setState({ setRepresentativeDetailsModal: false });
                //   }}
                //   cancelInvoiceAndRegenerateRenewalInvoice={this.cancelInvoiceAndRegenerateRenewalInvoice.bind(
                //     this
                //   )}
                //   isLoadingcancelInvoice={this.state.isLoadingcancelInvoice}
                // />
                <ManagePostingModal
                  councilIndex={this.state.councilIndex}
                  getMemberDirectoryData={this.state.renewalMemberList}
                  setRepresentativeDetailsModal={
                    this.state.setRepresentativeDetailsModal
                  }
                  charLimit={this.state.charLimit}
                  setOpenModal={() =>
                    this.setState({ setRepresentativeDetailsModal: false })
                  }
                  onClose={(e) => {
                    e.stopPropagation();
                    this.setState({ setRepresentativeDetailsModal: false });
                  }}
                  cancelInvoiceAndRegenerateRenewalInvoice={this.cancelInvoiceAndRegenerateRenewalInvoice.bind(
                    this
                  )}
                  isLoadingcancelInvoice={this.state.isLoadingcancelInvoice}
                />
              ) : null}
            </div>
          </div>
        </main>

        <div className="flex flex-wrap justify-between space-x-10 mt-12">
          <div>
            <button className="w-32 px-7 py-2 btn-sm btn-gray text-lg text-white" onClick={() => this.back()}>
              Back
            </button>
          </div>

        </div>
      </div>
    );
  }
}
